package com.eladfinish.bible.contest.features.installTime.domain.model

enum class InstallEvent {
    FIRST_INSTALL,
    UPDATE,
    NONE,
}
